import React from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

const StackedColumnChart = ({ options, periodData }) => {
  // const stackedColumnChartColors = getChartColorsArray(dataColors)
  // const options = {
  //   chart: {
  //     stacked: !0,
  //     toolbar: {
  //       show: false,
  //     },
  //     zoom: {
  //       enabled: !0,
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: !1,
  //       columnWidth: "25%",
  //       // endingShape: "rounded"
  //     },
  //   },
  //   dataLabels: {
  //     enabled: !1,
  //   },
  //   yaxis: {
  //     min: 0, // Asegura que el eje y comience en 0
  //     max: 100, // Asegura que el eje y termine en 100
  //     labels: {
  //       formatter: function (val) {
  //         return val + "%" // Agrega el símbolo de porcentaje a las etiquetas
  //       },
  //     },
  //   },
  //   xaxis: {
  //     show: true,
  //     categories: [
  //       "Ene",
  //       "Feb",
  //       "Mar",
  //       "Abr",
  //       "May",
  //       "Jun",
  //       "Jul",
  //       "Ago",
  //       "Sep",
  //       "Oct",
  //       "Nov",
  //       "Dic",
  //     ],
  //     labels: {
  //       show: true,
  //     },
  //   },
  //   colors: stackedColumnChartColors,
  //   legend: {
  //     position: "bottom",
  //   },
  //   fill: {
  //     opacity: 1,
  //   },
  // }
  //console.log("periodData: ", periodData)
  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={[...periodData]}
        type="bar"
        height="359"
        className="apex-charts"
      />
    </React.Fragment>
  )
}

// StackedColumnChart.propTypes = {
//   periodData: PropTypes.any,
// }
export default StackedColumnChart
